import moment from 'moment';
import Cookies from 'js-cookie';
import Config from '@/config';
import notify from '@/prototypes/notify';
import { app } from '@/main';
import * as base64 from './/base64';
import * as navigator from '@/lib/navigator';

// EL Dialog size
export const CalcDialogSize = size => {
  const windowWidth = window.innerWidth;

  let baseSize = 650;
  if (size) {
    baseSize = size;
  }

  if (windowWidth < 768) {
    return '90%';
  } else {
    return `${baseSize}px`;
  }
};

// オブジェクトの配列で重複しているものを排除する。
// data: 配列, key:ターゲットのキー
export const removeDuplicateObj = (data, key) => {
  return data.filter(function(x, i, self) {
    return self.findIndex(x2 => x2[key] === x[key]) === i;
  });
};

export function NumberFormat(value) {
  if (!value) return '0.00';
  const intPart = Math.floor(Number(value));
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  let floatPart = '.00';
  const value2Array = value.toString().split('.');
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString().slice(0, 2);
    if (floatPart.length === 1) {
      return intPartFormat + '.' + floatPart + '0';
    } else {
      return intPartFormat + '.' + floatPart;
    }
  } else {
    return intPartFormat + floatPart;
  }
}

export function showInvoice(company_id, month) {
  try {
    const invoiceLinkedId = base64.encode(company_id + '|' + month);
    let token;

    // Wave for Resellerログインの場合。 Case: Login by Wave for Reseller.
    const waveForResellerToken = Cookies.get('mo_wave_for_reseller_access_token', {
      path: Config.cookiePath,
    });

    if (waveForResellerToken) {
      token = waveForResellerToken;
    } else {
      token = Cookies.get('mo_access_token', { path: Config.cookiePath });
    }

    let base = `${navigator.locationOrigin}`;

    if (navigator.appEnv === 'localhost') {
      const port = Cookies.get('invoice_port');
      if (!port) throw new Error('Should set "port" on login page.');

      base = `${navigator.locationOrigin}:${port}`;
    }

    const invoiceUrl = `${base}/invoice/detail/${invoiceLinkedId}?access_token=${token}&wave=true`;

    if (invoiceUrl) window.open(invoiceUrl, '_blank');
    else
      throw new Error(
        // `Failed to create Invoice URL. baseDomain: ${base}, invoice_link_id: ${invoiceLinkedId}, password: ${password}, meta: ${meta}`
        `Failed to create Invoice URL. baseDomain: ${base}, invoice_link_id: ${invoiceLinkedId}`
      );
  } catch (e) {
    notify.error('access', app.$t('Usage Details'));
    // this.$message({
    //   message: this.$t('Login failed.'),
    //   type: 'error',
    // });
    console.error(e);
  }
}

/**
 * Sleeper: 一定時間たったらPromiseを返す
 * @param waitSeconds (Default: 1000)
 * @returns {Promise<resolve>}
 */
export const sleeper = waitSeconds => {
  let sec = 1000;
  if (waitSeconds) sec = waitSeconds;

  const response = {
    status: 'success',
  };

  return new Promise(resolve => {
    setTimeout(() => {
      resolve(response);
    }, sec);
  });
};

/**
 * clone objects
 * @param {object | []} obj
 * @return {object | []}
 */
import clonedeep from 'lodash.clonedeep';
export const cloneDeep = obj => {
  return clonedeep(obj);
};

/**
 * Debounce
 * @param {object | []} obj
 * @return {object | []}
 */
import _debounce from 'lodash.debounce';
export const debounce = (func, wait = 0, options) => {
  return _debounce(func, wait, options);
};

export function maintenanceTimer() {
  return moment().isBetween(Config.maintenance.start, Config.maintenance.end);
}

/**
 *  Color name formatter for Framework(Quasar)
 */
export const colorNameFormatter = type => {
  switch (type) {
    case 'primary':
      return 'primary';
    case 'secondary':
      return 'secondary';
    case 'accent':
      return 'accent';
    case 'dark':
      return 'dark';
    case 'success':
      return 'positive';
    case 'danger':
      return 'negative';
    case 'info':
      return 'info';
    case 'warning':
      return 'warning';
    case 'mute':
      return 'grey-3';
    case 'white':
      return 'white';
    default:
      return type;
  }
};
